"use client";

import React from "react";
import styles from "./Modal.module.less";
import { Image } from 'antd-mobile'
import closeIcon from '@/assets/img/close.png';

export interface ModalProps {
  /** 是否显示弹窗 */
  isOpen: boolean;
  /** 关闭弹窗回调 */
  onClose: () => void;
  /** 弹窗标题 */
  title?: string;
  /** 是否显示关闭按钮 */
  showCloseButton?: boolean;
  /** 是否允许点击空白区域关闭弹窗 */
  closeOnOverlayClick?: boolean;
  /** 自定义类名 */
  className?: string;
  /** 弹窗内容类名 */
  contentClassName?: string;
  /** 子组件 */
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  showCloseButton = true,
  closeOnOverlayClick = true,
  className,
  contentClassName,
  children,
}) => {
  // 处理遮罩层点击
  const handleOverlayClick = (e: React.MouseEvent) => {
    if (closeOnOverlayClick && e.target === e.currentTarget) {
      onClose();
    }
  };

  // 处理关闭按钮点击
  const handleCloseClick = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className={`${styles.modalOverlay} ${className || ""}`}
      onClick={handleOverlayClick}
    >
        {showCloseButton}
      <div 
        className={`${styles.modalContent} ${contentClassName || ""}`} 
        onClick={(e) => e.stopPropagation()}
      >
        {/* 头部区域 - 只有在有标题或显示关闭按钮时才渲染 */}
        {(title || showCloseButton) && (
          <div className={styles.modalHeader}>
            {title && <h2 className={styles.modalTitle}>{title}</h2>}
            {showCloseButton && (
              <Image
                src={closeIcon}
                alt="close"
                width={20}
                height={20}
                className={styles.closeButton}
                onClick={handleCloseClick}
              />
            )}
          </div>
        )}

        {/* 内容区域 */}
        <div className={styles.modalBody}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;